import React from 'react';
import Link from 'next/link';
import { profileLinks } from 'components/ProfileLayout';
import { useRouter } from 'next/router';

const ProfileSideNav = () => {
    const { pathname } = useRouter();

    return (
        <ul>
            {profileLinks.map((link, i) => {
                const isActive = pathname === link.href;
                return (
                    <li key={i} className="my-3">
                        <Link
                            href={link.href}
                            className={`py-2 px-4 rounded-full flex items-center gap-2  ${
                                isActive ? 'bg-brand' : 'hover:bg-brand-dull'
                            }`}
                        >
                            {link.icon && <link.icon className="w-5 h-5" />}
                            <span>{link.label}</span>
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

export default ProfileSideNav;
